import type { Video } from 'pkg/api/models/video';
import { VideoType } from 'pkg/api/models/video';
import { getYouTubeThumbnailUrl } from 'pkg/video';

export function thumbnail(video: Video): string {
	if (video.thumbnail) {
		return video.thumbnail?.url;
	} else if (video.type === VideoType.YouTube) {
		return getYouTubeThumbnailUrl(video.uri);
	} else {
		return '';
	}
}
